import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
    Container,
    Box,
    Typography,
    Snackbar,
    Alert,
    CircularProgress,
    Button,
} from "@mui/material";

import { useVerifyRegistrationEmail } from "../../hooks/authHooks";

const VerifyEmail = () => {
    const { uid, token } = useParams();
    const navigate = useNavigate();
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState("");
    const [snackbarSeverity, setSnackbarSeverity] = useState("error");
    const [isVerificationFailed, setIsVerificationFailed] = useState(false);

    const onSuccess = () => {
        setSnackbarMessage("Email verified successfully! Redirecting...");
        setSnackbarSeverity("success");
        setSnackbarOpen(true);
        navigate("/");
    };

    const onFailure = () => {
        setSnackbarMessage("Email verification failed. Please try again later.");
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
        setIsVerificationFailed(true);
    };

    const {
        mutate: verifyEmail,
        isPending: isEmailVerifying,
    } = useVerifyRegistrationEmail({ onSuccess, onFailure });

    useEffect(() => {
        if (uid && token) {
            verifyEmail({ uid, token });
        }
    }, [uid, token, verifyEmail]);

    return (
        <Container maxWidth="sm" sx={{ display: "flex", flexDirection: "column", alignItems: "center", mt: 5 }}>
            <Box sx={{ textAlign: "center", mb: 3 }}>
                {isEmailVerifying && (
                    <>
                        <CircularProgress />
                        <Typography variant="h6" sx={{ mt: 2 }}>
                            Verifying your email...
                        </Typography>
                    </>
                )}
                {!isEmailVerifying && isVerificationFailed && (
                    <Box>
                        <Typography variant="h6" color="error" sx={{ mb: 2 }}>
                            Email verification failed.
                        </Typography>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() => verifyEmail({ uid, token })}
                        >
                            Retry Verification
                        </Button>
                    </Box>
                )}
            </Box>

            <Snackbar
                open={snackbarOpen}
                autoHideDuration={3000}
                onClose={() => setSnackbarOpen(false)}
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            >
                <Alert
                    onClose={() => setSnackbarOpen(false)}
                    severity={snackbarSeverity}
                    sx={{ width: "100%" }}
                >
                    {snackbarMessage}
                </Alert>
            </Snackbar>
        </Container>
    );
};

export default VerifyEmail;
